'use client'

import FAQ from '@/components/faq'

export default function FAQPage() {
  return (
    <div className="faq">
      <FAQ />
    </div>
  )
}